import min from 'ml-array-min';
import { xRolling } from './xRolling';
/**
 * This function calculates a minimum within a rolling window
 *
 * @param array - the array that will be rotated
 * @param options - options
 */
export function xRollingMin(array, options = {}) {
    return xRolling(array, min, options);
}
//# sourceMappingURL=xRollingMin.js.map